import { CustomersTable } from "@/components/customers/CustomersTable";
import { PageHeader } from "@/components/shared/page-header";

export function CustomersPage() {
  return (
    <div className="space-y-6">
      <PageHeader title="Customers" />
      <CustomersTable />
    </div>
  );
}
